<template lang="pug">
  section.gal(:class="type")
    VuePictureSwipe(v-if="formatPics" :items="formatPics")
</template>
<script>
  import VuePictureSwipe from '@/components/VuePictureSwipe'
  export default {
    props: {
      pics: Array,
      type: String
    },
    components: {
      VuePictureSwipe
    },
    computed: {
      formatPics(){
        const formattedPics = []
        this.pics.map(pic => {
          formattedPics.push({
            src: pic.large.source_url,
            thumbnail: pic.thumbnail.source_url,
            w: pic.large.width,
            h: pic.large.height
          })
        })
        return formattedPics.reverse()
      }
    },
  }
</script>

<style scoped lang="scss">
  .gal{
    /deep/ {
      .teh-gallery{
        max-width: 1300px;
        margin-left: auto;
        margin-right: auto;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        grid-gap: 10px;
        grid-auto-flow: dense;
        figure{
          display: block;
          padding: 0;
          margin: 0;
          a,
          img{
            display: block;
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
          img{
            transition: all .3s;
            filter: grayscale(100%);
            &:hover{
              filter: grayscale(0);
            }
          }
        }
      }
    }
  }
  .gal:not(.firstgal){
    /deep/ {
      .teh-gallery{
        max-width: 1300px;
        margin-left: auto;
        margin-right: auto;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        grid-gap: 10px;
        grid-auto-flow: dense;
        figure{
          display: block;
          padding: 0;
          margin: 0;
          &.portrait{
            grid-row-end: span 2;
          }
          &.big{
            grid-row-end: span 2;
            grid-column-end: span 2;
          }
          a,
          img{
            display: block;
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
          img{
            transition: all .3s;
            filter: grayscale(100%);
            &:hover{
              filter: grayscale(0);
            }
          }
        }
      }
    }
    // /deep /img {
    //   transition: all .3s;
    //   filter: grayscale(100%);
    //   &:hover{
    //     filter: grayscale(0);
    //   }
    // }
  }
</style>
